import { render } from "./EventosComponent.vue?vue&type=template&id=509721f7&scoped=true"
import script from "./EventosComponent.vue?vue&type=script&lang=js"
export * from "./EventosComponent.vue?vue&type=script&lang=js"

import "./EventosComponent.vue?vue&type=style&index=0&id=509721f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509721f7"]])

export default __exports__